
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EarnedBadge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EarnedBadge"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"badge"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeView"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"earnedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"revokedDate"},"arguments":[],"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("./BadgeView.fragment.graphql").definitions));


    module.exports = doc
  
